import {
    AmplifyOutputsUnknown,
    LegacyConfig,
} from '@aws-amplify/core/internals/utils';
import { ResourcesConfig } from 'aws-amplify';

// see https://developer.mozilla.org/ja/docs/Web/HTML/Attributes/accept
export const UPLOADABLE_CONTENT_TYPES = [
    'image/jpeg',
    'image/png',
    'image/x-png',
    'image/vnd.mozilla.apng',
    'video/mp4',
    'text/plain',
    'text/csv',
    'text/json',
    'application/zip',
    'application/zip-compressed',
    'application/x-zip-compressed',
    'application/x-gzip',
    'application/gzip',
    'application/pdf',
    'application/x-pdf',
    'application/json',
    '.dxf',
    '.realm',
];
export const MAX_UPLOAD_SIZE = 50 * 1024 * 1024;
export const SHOW_UPLOAD_ALERT_SIZE = 1024 * 1024 * 1024;
export const CLEAR_TASK_INTERVAL = 10 * 60 * 1000;
export const AUTO_SIGNOUT_INTERVAL = 8 * 60 * 60 * 1000;

export const ROOT_FOLDER_NAME = 'ポータルトップ';

export const cognitoConstants = {
    Auth: {
        Cognito: {
            userPoolId: import.meta.env.VITE_AWS_USER_POOLS_ID,
            userPoolClientId: import.meta.env.VITE_AWS_USER_POOLS_CLIENT_ID,
        },
    },
} as const satisfies ResourcesConfig | LegacyConfig | AmplifyOutputsUnknown;

export const PAGER_LIMITS = [10, 20, 30];
